//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
export default {
  components: {},
  name: 'videoplay',
  props: ['videosrc'],
  data() {
    return {
      plyrObj: {}
    };
  },
  methods: {
    ...mapActions([])
  },
  watch: {},
  computed: {
    ...mapGetters([])
  },
  created() {
    this.plyrObj = this.videosrc;
    console.log(this.videosrc);
  },
  mounted() {}
};
